module.exports = __webpack_public_path__ + "img/cat1.1a6f749a.svg";